module.exports = __webpack_public_path__ + "../resources/images/illustration_draft-9dc10e2c71ee3730b093ad26c8109593.svg";